
































































































































































import { computed, defineComponent, ref, watch } from '@vue/composition-api'

import GitHubCorner from './GitHubCorner.vue'
import PagePreviewScrollbar from './components/PagePreviewScrollbar.vue'

import { IPagePreviewScrollbarMethods } from './types'
import { useWindowSize } from '@u3u/vue-hooks'
import debounce from 'lodash.debounce'
import { provideToast, useToast } from "vue-toastification/composition";
import "vue-toastification/dist/index.css";

export default defineComponent({
    name: 'App',
    components: {
        GitHubCorner,
        PagePreviewScrollbar
    },
    setup( props, { refs }){
        provideToast({ 
            toastClassName: "toast-notification",
            transition: "Vue-Toastification__fade",
            draggable: false,
            timeout: 3000
        })
        const toast = useToast()
        const { width, height } = useWindowSize()
        
        const images = ref(new Array(15).fill(0))

        const isShowBrowserScrollbar = ref(false)
        const isHideShorterHeight = ref(true)
        const isShowCloseButton = ref(true)
        const isAutoOpacity = ref(true)
        const isRepaintAnimation = ref(true)
        const isResizeAutoRepaint = ref(false)
        const disableRepaint = ref(false)
        const persist = ref(true)
        const targetSelector = ref("html")
        const elementToRmoveSelectors = ref([] as Array<string>)

        watch( isShowBrowserScrollbar, () => {
            const html = document.querySelector("body")
            if (isShowBrowserScrollbar.value) {
                html?.classList.add('show-scrollbar')
            }else{
                html?.classList.remove('show-scrollbar')
            }
        })

        function GetColor(isTrue: boolean){
            return isTrue ? "teal lighten-4" : 'deep-purple lighten-4'
        }

        function GetColor2(isTrue: boolean){
            return isTrue ? "teal lighten-4" : ''
        }

        function ResetScrollbar(){
            (refs.scrollbar as IPagePreviewScrollbarMethods)?.Reset();
        }

        function AddIcon(){
            images.value.push(0)
            ResetScrollbar()
        }

        function RemoveIcon(){
            images.value.pop()
            ResetScrollbar()
        }
        
        function PaintHtml(){
            targetSelector.value = 'html'
        }

        function PaintApp(){
            targetSelector.value = '#app'
        }

        function PaintImage(){
            targetSelector.value = '.images'
        }

        function PaintImageRight(){
            targetSelector.value = '.images .right'
        }

        function PaintImageRightRows(){
            targetSelector.value = '.images .right-rows'
        }

        function HandleRepainted(){
            toast.success("Repainted")
        }

        function HandleActive(){
            toast.success("Active")
        }

        function HandleInActive(){
            toast.success("InActive")
        }

        // =================================================================

        const scrollbarHeightPercent = ref(100.0)
        const isScrollbarAlignTop = ref(true)

        const DecrementScrollbarHeight = () => scrollbarHeightPercent.value -= 5
        const IncrementScrollbarHeight = () => scrollbarHeightPercent.value += 5

        const GetSCrollbarStyle = computed( () => ({
            height: `${height.value * (scrollbarHeightPercent.value / 100.0)}px !important`,
            top: `${isScrollbarAlignTop.value ? "0" : "unset"} !important`,
            bottom: `${!isScrollbarAlignTop.value ? "0" : "unset"} !important`,
        }))

        watch( scrollbarHeightPercent, debounce(ResetScrollbar, 300) )

        return {
            isHideShorterHeight,
            isShowCloseButton,
            isShowBrowserScrollbar,
            isAutoOpacity,
            isRepaintAnimation,
            isResizeAutoRepaint,
            disableRepaint,
            isScrollbarAlignTop,
            persist,
            targetSelector,
            elementToRmoveSelectors,
            images,
            scrollbarHeightPercent,
            
            AddIcon,
            RemoveIcon,
            ResetScrollbar,
            GetColor,
            GetColor2,
            
            PaintHtml,
            PaintApp,
            PaintImage,
            PaintImageRight,
            PaintImageRightRows,

            HandleRepainted,
            HandleActive,
            HandleInActive,

            DecrementScrollbarHeight,
            IncrementScrollbarHeight,
            GetSCrollbarStyle,
        }
    }        
})
